import React, { useEffect } from "react";
import Input from "../../../components/Input/Input";
import { FaTimes } from "react-icons/fa";
import "./AddAnnouncementMarqueeModal.css";

const AddAnnouncementMarqueeModal = ({
  showModal,
  announcementMarqueeText,
  setAnnouncementMarqueeText,
  saveLoading,
  onSave,
  onClose,
}) => {
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showModal]);

  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content add-edit-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Add Announcement Marquee</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
            disabled={saveLoading}
          >
            <FaTimes />
          </button>
        </div>

        <div className="profile-form">
          <Input
            title="Announcement Marquee Text"
            type="text"
            placeholder="Enter announcement marquee text"
            value={announcementMarqueeText}
            onChange={(e) => setAnnouncementMarqueeText(e.target.value)}
          />

          <div className="form-actions">
            <button
              type="button"
              onClick={onSave}
              disabled={saveLoading}
              aria-busy={saveLoading}
            >
              {saveLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAnnouncementMarqueeModal;
